import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import moment from 'moment'
import { pdf } from '@react-pdf/renderer'
import { Button, Input, Loader, Table } from 'semantic-ui-react'

import { useSchedule } from '../../hooks/schedules'

import ReportPdf from '../../components/ReportPdf'
import SideMenu from '../../components/SideMenu'
import Header from '../../components/Header'

import {
  Container,
  MainBody,
  Load,
  Content,
  HeaderContent,
  Title,
  TableColumnText,
  TableDataText,
} from './styles'

import { styleSheet } from '../../assets/styles/global'

const Report: React.FC = () => {
  const [inputMonthValue, setInputMonthValue] = useState(moment().format('YYYY-MM'))

  const history = useHistory()
  const {
    loadReportData,
    projectsReport,
    schedulesReport,
    isLoading
  } = useSchedule()

  const handleLogout = async () => {
    await localStorage.removeItem('ethosxAnalista:token')
    await sessionStorage.removeItem('analystName')
    await sessionStorage.removeItem('token')

    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(name => {
          caches.delete(name);
        })
      });
    }

    history.push('/login')
    window.location.reload();
  }

  async function loadReport(date: string) {
    const month = date.split('-')[1]
    const year = date.split('-')[0]
    setInputMonthValue(date)
    await loadReportData(Number(month), Number(year))
  }

  async function handleOpenPdf() {
    const date = `${moment(inputMonthValue).format('MMMM')} de ${moment(inputMonthValue).format('YYYY')}`
    const blob = await pdf(<ReportPdf schedulesReport={schedulesReport} projectsReport={projectsReport}  date={date} />).toBlob();
    const fileURL = URL.createObjectURL(blob);
    window.open(fileURL, '_blank');
  }

  useEffect(() => {
    loadReport(inputMonthValue)
  }, [])

  return (
    <Container>
      <SideMenu currentMenu="report" />

      {
        isLoading ? <Load><Loader active inline='centered'>Carregando</Loader></Load>
          :
          <MainBody>
            <Header screen="Relatório" logout={handleLogout} />

            <Content>
              <HeaderContent>
                <Title>Relatório Atividades</Title>
                <div>
                  <Input
                    type="month"
                    size="big"
                    value={inputMonthValue}
                    onChange={(value) => loadReport(value.target.value)}
                  />
                  <Button
                    size="huge"
                    style={{ backgroundColor: styleSheet.colorMain, color: styleSheet.shape, marginLeft: "1rem" }}
                    onClick={handleOpenPdf}
                  >
                    Exportar para PDF
                  </Button>
                </div>  
              </HeaderContent>

              <Table celled compact  sortable selectable color='teal'>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Os
                      </TableColumnText>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Data
                      </TableColumnText>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Cliente
                      </TableColumnText>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Projeto
                      </TableColumnText>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Local
                      </TableColumnText>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Inicio
                      </TableColumnText>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Fim
                      </TableColumnText>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Desconto
                      </TableColumnText>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Despesa - R$
                      </TableColumnText>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Total - HR
                      </TableColumnText>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Valor - HR
                      </TableColumnText>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Total - R$
                      </TableColumnText>
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                {
                  schedulesReport.map(item => (
                    <Table.Row key={item.key}>
                        <Table.Cell><TableDataText>{item.os}</TableDataText></Table.Cell>
                        <Table.Cell><TableDataText>{moment(item.data).format('DD/MM/YYYY')}</TableDataText></Table.Cell>
                        <Table.Cell><TableDataText>{item.nomecli}</TableDataText></Table.Cell>
                        <Table.Cell><TableDataText>{item.projeto}</TableDataText></Table.Cell>
                        <Table.Cell><TableDataText>{item.local}</TableDataText></Table.Cell>
                        <Table.Cell textAlign="center"><TableDataText>{item.horaini}</TableDataText></Table.Cell>
                        <Table.Cell textAlign="center"><TableDataText>{item.horafim}</TableDataText></Table.Cell>
                        <Table.Cell><TableDataText>{item.desconto}</TableDataText></Table.Cell>
                        <Table.Cell textAlign="right"><TableDataText>R$ {item.totDesp}</TableDataText></Table.Cell>
                        <Table.Cell textAlign="center"><TableDataText>{item.horatot}</TableDataText></Table.Cell>
                        <Table.Cell textAlign="right"><TableDataText>R$ {item.valortot}</TableDataText></Table.Cell>
                        <Table.Cell textAlign="right"><TableDataText>R$ {item.valortot + item.totDesp}</TableDataText></Table.Cell>
                    </Table.Row>
                  ))
                }
                  <Table.Row positive>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell textAlign="right"><TableDataText>R$ {schedulesReport.reduce((acc, schedule) => acc += schedule.totDesp, 0)}</TableDataText></Table.Cell>
                    <Table.Cell textAlign="center"><TableDataText>{schedulesReport.reduce((acc, schedule) => acc += schedule.horatot, 0)}</TableDataText></Table.Cell>
                    <Table.Cell textAlign="right"><TableDataText>R$ {schedulesReport.reduce((acc, schedule) => acc += schedule.valortot, 0)}</TableDataText></Table.Cell>
                    <Table.Cell textAlign="right"><TableDataText>R$ {schedulesReport.reduce((acc, schedule) => acc += schedule.valortot, 0).toFixed(2)}</TableDataText></Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>

              <HeaderContent>
                <Title>Relatório Projetos</Title>
              </HeaderContent>

              <Table celled compact  sortable selectable color='teal'>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Projeto
                      </TableColumnText>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Horas
                      </TableColumnText>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Despesa
                      </TableColumnText>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Valor - HR
                      </TableColumnText>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <TableColumnText>
                        Total
                      </TableColumnText>
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {
                    projectsReport.map(project => (
                      <Table.Row key={project.nome}>
                        <Table.Cell><TableDataText>{project.nome}</TableDataText></Table.Cell>
                        <Table.Cell textAlign="center"><TableDataText>{project.horas}</TableDataText></Table.Cell>
                        <Table.Cell textAlign="right"><TableDataText>R$ {project.despesa}</TableDataText></Table.Cell>
                        <Table.Cell textAlign="right"><TableDataText>R$ {project.valor}</TableDataText></Table.Cell>
                        <Table.Cell textAlign="right"><TableDataText>R$ {project.valor + project.despesa}</TableDataText></Table.Cell>
                      </Table.Row>
                    ))
                  }
                  <Table.Row positive>
                    <Table.Cell><TableDataText></TableDataText></Table.Cell>
                    <Table.Cell textAlign="center"><TableDataText>{projectsReport.reduce((acc, project) => acc += project.horas, 0)}</TableDataText></Table.Cell>
                    <Table.Cell textAlign="right"><TableDataText>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(projectsReport.reduce((acc, project) => acc += project.despesa, 0))}</TableDataText></Table.Cell>
                    <Table.Cell textAlign="right"><TableDataText>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(projectsReport.reduce((acc, project) => acc += project.valor, 0))}</TableDataText></Table.Cell>
                    <Table.Cell textAlign="right"><TableDataText>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(projectsReport.reduce((acc, project) => acc += project.valor, 0) + projectsReport.reduce((acc, project) => acc += project.despesa, 0))}</TableDataText></Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Content>
          </MainBody>
      }
    </Container>
  )
}

export default Report;
